const imageCfUrl = `${process.env.VUE_APP_MEDIA_API_URL}/cdn-cgi/image/`

export default imageCfUrl
